import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import PaymentModalService from "../../service/payment/payment_modal_service";
import PaymentMiddlewareUrlService from "../../service/payment/payment_middleware_url_service";

export default class extends Controller {
  static values = {
    coupon: String,
    newHome: Boolean,
  };

  static targets = [
    "originalLiteYearPrice",
    "originalPremiumYearPrice",
    "originalLiteMonthPrice",
    "originalPremiumMonthPrice",
    "liteYear",
    "premiumYear",
    "lite",
    "premium",
    "finalLiteYearPrice",
    "finalPremiumYearPrice",
    "saveLiteYear",
    "saveLite",
    "savePremium",
    "free",
    "monthlyPlan",
    "annualPlan",
    "getPremiumYearBtn",
    "getPremiumMonthBtn",
    "getLiteYearBtn",
    "getLiteMonthBtn",
    "currencyContainer",
    "selectedCurrency",
    "currencyContainerForm",
  ];

  symbol = {
    aud: "A$",
    brl: "R$",
    cad: "C$",
    eur: "€",
    gbp: "£",
    idr: "Rp",
    inr: "₹",
    sar: "SR",
    thb: "฿",
    uah: "₴",
    usd: "$",
    vnd: "₫",
  };

  plansData = {};

  connect() {
    this.currencyDropDown()
    let planPriceRequestData = {};
    if (this.couponValue) {
      planPriceRequestData = {
        coupon: this.couponValue,
      };
    }
    axios.post("/get-all-plans", planPriceRequestData).then(({ data }) => {
      this.plansData = data;
      this.setData("usd");
    });
  }
currencyDropDown(){
    const currencyContainer = this.currencyContainerTarget;
    const selectedCurrency = this.selectedCurrencyTarget;
    const dropdownItems = currencyContainer.querySelectorAll('.dropdown-item');
    const hiddenSelect =  this.currencyContainerFormTarget;

    dropdownItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const value = item.getAttribute('data-value');
        selectedCurrency.textContent = value.toUpperCase();

        hiddenSelect.value = value;

        const changeEvent = new Event('change', { bubbles: true });
        hiddenSelect.dispatchEvent(changeEvent);
      });
    });
}
  setData(currency) {
    if (this.couponValue !== "") {
      this.setOriginalPrice(
        this.originalLiteYearPriceTargets,
        this.plansData["lite_year"],
        currency,
        true
      );
      this.setOriginalPrice(
        this.originalPremiumYearPriceTargets,
        this.plansData["premium_year"],
        currency,
        true
      );
      this.setOriginalPrice(
        this.originalLiteMonthPriceTargets,
        this.plansData["lite_month"],
        currency
      );
      this.setOriginalPrice(
        this.originalPremiumMonthPriceTargets,
        this.plansData["premium_month"],
        currency
      );

      this.setFinalPrice(
        this.finalLiteYearPriceTargets,
        this.plansData["lite_year"],
        currency
      );
      this.setFinalPrice(
        this.finalPremiumYearPriceTargets,
        this.plansData["premium_year"],
        currency
      );
    }

    this.setPrice(
      this.liteYearTargets,
      this.plansData["lite_year"],
      currency,
      true
    );
    this.setPrice(
      this.premiumYearTargets,
      this.plansData["premium_year"],
      currency,
      true
    );
    this.setPrice(
      this.liteTargets,
      this.plansData["lite_month"],
      currency,
      false
    );
    this.setPrice(
      this.premiumTargets,
      this.plansData["premium_month"],
      currency,
      false
    );
    this.calculateSavePrice(currency);
    this.freeTargets.forEach(
      (target) => (target.innerHTML = `${this.symbol[currency]}0`)
    );
  }

  setOriginalPrice(targets, data, currency, isYear) {
    const originalPrice = data.find((item) => item.currency === currency)['price_per_unit'];
    targets.forEach((target) => {
      const amount = isYear ? (originalPrice / 12).toFixed(2) : originalPrice;
      const priceString = `${this.symbol[currency]}${amount}`;

      target.innerHTML = priceString.length > 5 ? '' : priceString;
    });
  }

  setPrice(targets, data, currency, isYear) {
    const price = data.find((item) => item.currency === currency).amount;
    targets.forEach((target) => {
      const amount = isYear ? (price / 12).toFixed(2) : price;
      target.innerHTML = `${this.symbol[currency]}${amount}`;
    });
  }

  setFinalPrice(targets, data, currency) {
    const price = data.find((item) => item.currency === currency)['amount'];
    targets.forEach((target) => {
      target.innerHTML = `${this.symbol[currency]}${price}`;
    });
  }

  calculateSavePrice(currency) {
    const liteYearData = this.plansData["lite_year"].find((item) => item.currency === currency);
    const liteMonthData = this.plansData["lite_month"].find((item) => item.currency === currency);
    const premiumYearData = this.plansData["premium_year"].find((item) => item.currency === currency);
    const premiumMonthData = this.plansData["premium_month"].find((item) => item.currency === currency);

    const liteAmountYear = liteYearData['amount'];
    const liteMonthPricePerUnit = liteMonthData['price_per_unit'];
    const liteMonthPriceFor12Month = liteMonthPricePerUnit * 12;
    const liteYearProfit = this.roundPrice(liteMonthPriceFor12Month - liteAmountYear);

    const premiumAmountYear = premiumYearData['amount'];
    const premiumMonthPricePerUnit = premiumMonthData['price_per_unit'];
    const premiumMonthPriceFor12Month = premiumMonthPricePerUnit * 12;
    const premiumYearProfit = this.roundPrice(premiumMonthPriceFor12Month - premiumAmountYear);

    this.saveLiteTargets.forEach((target) => {
      target.innerHTML = `${this.symbol[currency]}${liteYearProfit}`;
    });

    this.savePremiumTargets.forEach((target) => {
      target.innerHTML = `${this.symbol[currency]}${premiumYearProfit}`;
    });
  }

  roundPrice(price)
  {
    price = Number(price.toFixed(2));
    if (price % 1 === 0) {
      return Math.round(price);
    }

    return price;
  }

  toggle(event) {
    this.setData(event.target.value);
  }

  selectMonthPlan() {
    this.monthlyPlanTargets.forEach((item) => {
      item.classList.add("d-none");
    });
    this.annualPlanTargets.forEach((item) => {
      item.classList.remove("d-none");
    });
  }

  selectAnnualPlan() {
    this.monthlyPlanTargets.forEach((item) => {
      item.classList.remove("d-none");
    });
    this.annualPlanTargets.forEach((item) => {
      item.classList.add("d-none");
    });
  }

  getPlanBtn(e) {
    const userId = document.querySelector("[data-user-id]")?.dataset.userId;
    const locale = window.location.pathname.split("/")[1].toUpperCase();
    const currency = this.currencyContainerFormTarget.value.toUpperCase();
    let itemName;
    let idx;
    let price;
    const type = document.getElementById("btnradio1").checked ? "Yearly" : "Monthly";

    if (e.params.label === "free") {
      itemName = "Free";
      idx = 1;
      price = 0;
    } else if (e.params.label === "lite") {
      itemName = "Lite";
      idx = 2;
      price = type === "Yearly"
        ? Number(this.liteYearTarget.innerText.replace(/[^\d.]/g, "")) * 12
        : Number(this.liteTarget.innerText.replace(/[^\d.]/g, ""));
      PaymentModalService.setChoosePaymentMethodActions({
        cardBtnActiion: "checkoutLiteMultisubCard",
        paypalBtnAction: "checkoutLiteMultisubPaypal",
        subscriptionType: type === "Yearly" ? PaymentMiddlewareUrlService.liteYearType : PaymentMiddlewareUrlService.liteMonthType,
        coupon: this.couponValue,
        currency: currency.toLowerCase(),
      });
    } else if (e.params.label === "premium") {
      itemName = "Premium";
      idx = 3;
      price = type === "Yearly" ? Number(this.premiumYearTarget.innerText.replace(/[^\d.]/g, "")) * 12 : Number(this.premiumTarget.innerText.replace(/[^\d.]/g, ""));
      PaymentModalService.setChoosePaymentMethodActions({
        cardBtnActiion: "checkoutPremiumMultisubCard",
        paypalBtnAction: "checkoutPremiumMultisubPaypal",
        subscriptionType: type === "Yearly" ? PaymentMiddlewareUrlService.premiumYearType : PaymentMiddlewareUrlService.premiumMonthType,
        coupon: this.couponValue,
        currency: currency.toLowerCase(),
      });
    }

    gtag("event", "select_item", {
      site_language: locale.length > 2 ? "EN" : locale,
      items: [{
        item_name: itemName,
        item_id: `subscription_${e.params.label}_${userId}`,
        price: price.toFixed(2),
        currency: currency,
        item_category: "Pricing",
        item_list_name: "Payment&Subscription",
        item_variant: type,
        index: idx
      }]
    });
    if (typeof rdt === "function") {
      rdt("track", "Custom", { customEventName: "select_item" });
    }
  }

  multiSubscribeNavigate(e) {
    const locale = document.querySelector('[data-locale]').getAttribute('data-locale')
    document.cookie = `multiSub=1; path=${locale === 'en' ? "" : `/${locale}`}/subscription`;
    window.location.href = e.target.dataset.href;
  }
}
